import { render } from "./MyScore.vue?vue&type=template&id=a4011296"
import script from "./MyScore.vue?vue&type=script&lang=js"
export * from "./MyScore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__